import React, { useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import axios from "axios";
import logo5 from "../../header/logo5.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Partnerwithus = () => {
  const [formData, setFormData] = useState({
    institute_name: "",
    website: "",
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    designation: "",
    phone: "",
    location: "",
  });
  const [passwordType, setPasswordType] = useState("password");
  const [errors, setErrors] = useState({});
  const [agree, setAgree] = useState(false);
  // const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    let newErrors = {};

    // Institute Name
    if (!formData.institute_name.trim()) {
      newErrors.institute_name = "Company/Institute name is required.";
    }

    // Website
    if (!formData.website.trim()) {
      newErrors.website = "Website is required.";
    } else {
      const websiteRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;
      if (!websiteRegex.test(formData.website)) {
        newErrors.website = "Enter a valid website URL.";
      }
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email address.";
    }

    // Password
    if (!formData.password) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters.";
    }

    // First Name
    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required.";
    }

    // Last Name
    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required.";
    }

    // Designation
    if (!formData.designation.trim()) {
      newErrors.designation = "Position is required.";
    }

    // Phone
    if (!formData.phone.trim()) {
      newErrors.phone = "Contact number is required.";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit contact number.";
    }

    // Location
    if (!formData.location.trim()) {
      newErrors.location = "Location is required.";
    }

    if (!agree) {
      newErrors.agree = "You must accept the Terms & Privacy Policy.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    const apiUrl = "https://api.ultraaura.education/api/vendors/register";

    try {
      const response = await axios.post(apiUrl, formData);

      toast.success(
        response.data.message ||
          "Registration successful! Please check your email for verification.",
      );

      setFormData({
        institute_name: "",
        website: "",
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        designation: "",
        phone: "",
        location: "",
      });

      setErrors({});
    } catch (error) {
      toast.error(error.response?.data?.message || "Registration failed");
    } finally {
      setIsLoading(false);
    }
  };

  var settings = {
    items: 1,
    margin: 25,
    dots: true,
    nav: true,
    navText: [
      '<i className="fas fa-arrow-left"></i>',
      '<i className="fas fa-arrow-right"></i>',
    ],
    loop: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1170: {
        items: 1,
      },
    },
  };

  return (
    <>
      <div className="main-wrapper log-wrap">
        <div className="row">
          <div className="col-md-6 login-bg">
            <OwlCarousel
              {...settings}
              className="owl-carousel login-slide owl-theme"
            >
              <div className="welcome-login">
                <div className="login-banner">
                  <img src={logo5} className="img-fluid" alt="Logo" />
                </div>
                <div className="mentor-course text-center">
                  <h2>Become a Partner and Scale Your Impact with UltraAura</h2>
                  {/* <ul className="">
                    <li>Signup</li>
                    <li>Add courses</li>
                    <li>You are Live Globally</li>
                  </ul> */}
                </div>
              </div>
            </OwlCarousel>
          </div>
          <div className="col-md-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="w-100">
                  <div className="img-logo">
                    <div className="back-home">
                      <Link to="https://vendors.ultraaura.education">
                        Back to Home
                      </Link>
                    </div>
                  </div>
                  <h1>Sign up into Your Account</h1>
                  <form onSubmit={handleSubmit}>
                    <div className="input-block">
                      <label className="form-control-label">
                        Your Company / Institute Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your institute name"
                        name="institute_name"
                        value={formData.institute_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">
                        Website or Online link if any
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your website"
                        name="website"
                        value={formData.website}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Email ID</label>
                      <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />

                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Password</label>
                      <div className="pass-group">
                        <input
                          type={passwordType}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        />

                        {errors.password && (
                          <small className="text-danger">
                            {errors.password}
                          </small>
                        )}
                        <span
                          className="toggle-password feather-eye"
                          onClick={togglePassword}
                        >
                          {passwordType === "password" ? (
                            <FeatherIcon icon="eye" />
                          ) : (
                            <FeatherIcon icon="eye-off" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">First Name</label>
                      <input
                        type="text"
                        className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                      />

                      {errors.first_name && (
                        <small className="text-danger">
                          {errors.first_name}
                        </small>
                      )}
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Last Name</label>
                      <input
                        type="text"
                        className={`form-control ${errors.last_name ? "is-invalid" : ""}`}
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChange}
                      />

                      {errors.last_name && (
                        <small className="text-danger">
                          {errors.last_name}
                        </small>
                      )}
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">My Postion</label>
                      <input
                        type="text"
                        className={`form-control ${errors.designation ? "is-invalid" : ""}`}
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                      />

                      {errors.designation && (
                        <small className="text-danger">
                          {errors.designation}
                        </small>
                      )}
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">
                        Contact Number
                      </label>
                      <input
                        type="tel"
                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />

                      {errors.phone && (
                        <small className="text-danger">{errors.phone}</small>
                      )}
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Location</label>
                      <input
                        type="text"
                        className={`form-control ${errors.location ? "is-invalid" : ""}`}
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                      />

                      {errors.location && (
                        <small className="text-danger">{errors.location}</small>
                      )}
                    </div>

                    <div className="form-check remember-me">
                      <label className="form-check-label mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={agree}
                          onChange={(e) => setAgree(e.target.checked)}
                        />
                        I agree to the&nbsp;
                        <Link to="/term-condition">Terms of Service</Link>{" "}
                        and&nbsp;
                        <Link to="/privacy-policy">Privacy Policy.</Link>
                      </label>
                      {errors.agree && (
                        <small className="text-danger d-block">
                          {errors.agree}
                        </small>
                      )}
                    </div>
                    <div className="d-grid">
                      <button
                        disabled={isLoading}
                        className="btn btn-start"
                        type="submit"
                      >
                        {isLoading ? "Submitting..." : "Sign up"}
                      </button>
                    </div>

                    <div className="signup-link text-center mt-4">
                      <p className="mb-0">
                        Already have an account?{" "}
                        <Link
                          to="/partner-signin"
                          className="text-primary fw-bold"
                        >
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Partnerwithus;
